// extracted by mini-css-extract-plugin
export default {"cv-upload-container":"cv-upload-autofill_cv-upload-container__2KrSX","add-cv-btn":"cv-upload-autofill_add-cv-btn__6RVAA"};